import { LinkIcon } from '@heroicons/react/24/outline';
import { ColumnDef } from '@tanstack/react-table';
import Button from 'app/components/Button/Button';

import { useCourseProgressLink } from 'core/hooks/useCourseProgressLink';
import { ICourseProgressDAO } from 'types/domain/permissions';
import { timeAgo } from 'utils/convertDate';

export const columns: ColumnDef<ICourseProgressDAO>[] = [
  {
    header: 'Name',
    accessorKey: 'name',
    accessorFn: row => row.organisationUser.name || row.organisationUser.email || 'Anonymous Learner',
  },
  {
    accessorKey: 'date',
    header: 'Date',
    cell: data => {
      const date = data.row.original.modified?.date || data.row.original.created?.date;
      return <>{timeAgo(new Date(date))}</>;
    },
  },
  // {
  //   accessorKey: 'link',
  //   header: 'link',
  //   cell: data => {
  //     // eslint-disable-next-line react-hooks/rules-of-hooks
  //     const { copyLink, isCopy } = useCourseProgressLink(data.row.original, data.row.original.id);

  //     if (data.row.original.inviteUrl)
  //       return (
  //         <Button variant="secondary" loading={isCopy} onClick={copyLink}>
  //           <LinkIcon className="w-5 h-5" />
  //         </Button>
  //       );
  //   },
  // },
];
